import {AbstractEvent} from "@/modules/base/events";
import {Negotiation} from "@/modules/diplomacy/entity";

export class AfterNegotiationEvent extends AbstractEvent {
  constructor(
    public negotiation: Negotiation,
    public progress: number,
    public patience: number,
  ) {
    super();
  }
}